import React from 'react'
import { useSelector } from 'react-redux'
import CartConsignmetView from '../../../containers/Inventory/Consignment/CartConsignmet/CartConsignmet'

const CartConsignment = () => {
  const { bagConsignations } = useSelector(state => state.inventory)
  return (
    <CartConsignmetView bag={bagConsignations}/>
  )
}

export default CartConsignment